/* eslint-disable no-use-before-define */
import CONFIG from "../config/config";
import logger from "./logger";
import { NProgress } from "nprogress-v2";
import { broadcastLogout } from "../hooks/useSessionSync";
import { toast, Bounce } from "react-toastify";
import "nprogress-v2/dist/index.css";

export const API_ACTIVITY_EVENT = 'api-activity';

const ApiClient = async (
  endpoint,
  method = "GET",
  body = null,
  headers = {},
) => {
  window.dispatchEvent(new Event(API_ACTIVITY_EVENT));
  NProgress.start();

  const config = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    credentials: "include",
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${CONFIG.BASE_URL}${endpoint}`, config);

    if (response.status === 401) {
      // Skip logout handling if this IS the logout endpoint to avoid infinite loops
      if (!endpoint.includes('/logout')) {
        const unAuthData = await response.json();
        toast.error(unAuthData?.error, {
          toastId: "unauthorized-user",
          position: "top-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });

        // Try to call logout, but don't wait for it if it fails
        try {
          await get("/api/v1/auth/logout");
        } catch (logoutError) {
          // Ignore logout errors, just clean up locally
          console.error('Logout call failed, cleaning up locally:', logoutError);
        }
      }

      localStorage.clear();
      sessionStorage.clear();
      broadcastLogout();
      return null;
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "API request failed");
    }

    return await response.json();
  } catch (error) {
    logger.error(`Error in API call: ${method} ${endpoint}`, error);
    throw error;
  } finally {
    NProgress.done();
  }
};

export const get = (endpoint, headers = {}) => ApiClient(endpoint, "GET", null, headers);

export const post = (endpoint, body, headers = {}) => ApiClient(endpoint, "POST", body, headers);

export const put = (endpoint, body, headers = {}) => ApiClient(endpoint, "PUT", body, headers);

export const del = (endpoint, headers = {}) => ApiClient(endpoint, "DELETE", null, headers);

export default ApiClient;
